import React, { useRef, useState, useEffect } from "react";
import ClientModal from "./ClientModal";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const clientsData = [
  {
    id: 1,
    name: "Scentivia Perfumes",
    logo: "/logos/Scentivia Perfumes Logo.png",
    products: [
      {
        name: "Scentivia Men's Collection For Men",
        price: "Starting from ₹299",
        image: "/products/Scentivia Product 1.webp",
        link: "https://scentivia.shop/collections/for-men-scentivia",
      },
      {
        name: "Scentivia Women's Collection For Women",
        price: "Starting from ₹299",
        image: "/products/Scentivia Product 2.webp",
        link: "https://scentivia.shop/collections/for-women-scentivia",
      },
      {
        name: "Scentivia Unisex Collection For All",
        price: "Starting from ₹299",
        image: "/products/Scentivia Product 3.webp",
        link: "https://scentivia.shop/collections/for-all-scentivia",
      },
    ],
  },
  {
    id: 2,
    name: "Globex Inc",
    logo: "/logos/logo1.jpg",
    products: [
      {
        name: "Globex Product A",
        price: "$99",
        image: "/products/product1.jpg",
        link: "#",
      },
      {
        name: "Globex Product B",
        price: "$129",
        image: "/products/product1.jpg",
        link: "#",
      },
    ],
  },
  {
    id: 3,
    name: "Wayne Enterprises",
    logo: "/logos/logo1.jpg",
    products: [
      {
        name: "Batmobile",
        price: "$1,000,000",
        image: "/products/product1.jpg",
        link: "#",
      },
    ],
  },
  {
    id: 4,
    name: "Stark Industries",
    logo: "/logos/logo1.jpg",
    products: [
      {
        name: "Iron Suit",
        price: "$10,000,000",
        image: "/products/product1.jpg",
        link: "#",
      },
    ],
  },
  {
    id: 5,
    name: "Oscorp",
    logo: "/logos/logo1.jpg",
    products: [
      {
        name: "Glider",
        price: "$500,000",
        image: "/products/product1.jpg",
        link: "#",
      },
    ],
  },
  {
    id: 6,
    name: "Cyberdyne Systems",
    logo: "/logos/logo1.jpg",
    products: [
      {
        name: "T-800",
        price: "$2,000,000",
        image: "/products/product1.jpg",
        link: "#",
      },
    ],
  },
];

function ClientsSection() {
  const [selectedClient, setSelectedClient] = useState(null);
  const scrollRef = useRef(null);
  const [showArrows, setShowArrows] = useState(false);
  const navigate = useNavigate();

  const cardWidth = 220;
  const scrollInterval = 3000;

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -cardWidth : cardWidth,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const checkOverflow = () => {
      const el = scrollRef.current;
      setShowArrows(el && el.scrollWidth > el.clientWidth);
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    const interval = setInterval(() => {
      const el = scrollRef.current;
      if (!el) return;

      const maxScroll = el.scrollWidth - el.clientWidth;

      if (el.scrollLeft >= maxScroll) {
        el.scrollLeft = 0;
      } else {
        el.scrollBy({ left: cardWidth, behavior: "smooth" });
      }
    }, scrollInterval);

    return () => {
      window.removeEventListener("resize", checkOverflow);
      clearInterval(interval);
    };
  }, []);

  return (
    <section className="bg-primary-color py-16 relative">
      <h2 className="text-3xl font-extrabold text-center text-secondary-color mb-12 tracking-wide">
        Our Clients
      </h2>

      {/* Arrows */}
      {showArrows && (
        <>
          <button
            onClick={() => scroll("left")}
            className="absolute left-6 top-1/2 -translate-y-1/2 z-20 p-3 bg-secondary-color/45 backdrop-blur-md text-white rounded-full shadow-md hover:bg-secondary-color/85 transition"
          >
            <ChevronLeft size={28} />
          </button>

          <button
            onClick={() => scroll("right")}
            className="absolute right-6 top-1/2 -translate-y-1/2 z-20 p-3 bg-secondary-color/45 backdrop-blur-md text-white rounded-full shadow-md hover:bg-secondary-color/85 transition"
          >
            <ChevronRight size={28} />
          </button>
        </>
      )}

      {/* Cards */}
      <div className="max-w-7xl mx-auto overflow-visible px-4">
        <div
          ref={scrollRef}
          className="flex gap-8 overflow-x-auto scroll-smooth scrollbar-hide pb-4 snap-x snap-mandatory"
        >
          {clientsData.map((client) => (
            <div
              key={client.id}
              onClick={() => setSelectedClient(client)}
              className="
                min-w-[200px] 
                bg-secondary-color/45 
                border border-white/20 
                backdrop-blur-xl 
                text-white 
                rounded-2xl 
                shadow-lg 
                cursor-pointer 
                p-6 
                flex flex-col 
                items-center 
                hover:scale-105 
                transition-transform 
                duration-300 
                snap-start 
                hover:bg-secondary-color/85
              "
              style={{ transformOrigin: "center bottom" }}
            >
              <img
                src={client.logo}
                alt={client.name}
                className="w-28 h-28 object-contain mb-4"
              />
              <p className="font-semibold text-lg text-center">{client.name}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Marketplace Button */}
      <div className="flex justify-center mt-10">
        <button
          onClick={() => navigate("/marketplace")}
          className="px-8 py-3 bg-secondary-color/65 text-white rounded-full shadow-lg hover:bg-secondary-color transition font-semibold text-lg"
        >
          Visit Marketplace
        </button>
      </div>

      {/* Modal */}
      {selectedClient && (
        <ClientModal
          client={selectedClient}
          onClose={() => setSelectedClient(null)}
        />
      )}
    </section>
  );
}

export default ClientsSection;
